document.addEventListener('DOMContentLoaded', function() {
  const burgerButton = document.querySelector('.b-burger');
  const middleElement = document.querySelector('.b-sidebar');
  const headerBottom = document.querySelector('.b-h__bottom');

  function toggleSidebar() {
    const isOpened = middleElement.classList.toggle('b-sidebar_opened');
    document.body.classList.toggle('_overflow', isOpened);
    burgerButton.classList.toggle('b-burger_active', isOpened);
    headerBottom.classList.toggle('b-h__bottom_hidden', isOpened);
  }

  function closeSidebar() {
    middleElement.classList.remove('b-sidebar_opened');
    document.body.classList.remove('_overflow');
    burgerButton.classList.remove('b-burger_active');
    headerBottom.classList.remove('b-h__bottom_hidden');
  }

  burgerButton.addEventListener('click', toggleSidebar);

  document.addEventListener('click', function(event) {
    if (
      !middleElement.contains(event.target) &&
      !burgerButton.contains(event.target) &&
      middleElement.classList.contains('b-sidebar_opened')
    ) {
      closeSidebar();
    }
  });
});
